import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from '../ConfirmationMessage/ConfirmationMsg.css';

const cx = classNames.bind(styles);

function OrderNumber({ orderId }) {
    return (
        <div>
            <p
                className={`${cx('orderNumberLabel')} ${dt(['text-normal'])}`}
                data-automation-id="orderNumber"
            >
                Order Number:
            </p>
            <p className={dt(['text-normal'])} data-automation-id="orderId">
                <strong className={`${cx('orderNumberStrong')} ${dt(['pointer-events-none'])}`}>
                    {orderId}
                </strong>
            </p>
        </div>
    );
}

OrderNumber.defaultProps = {
    orderId: '',
};

OrderNumber.propTypes = {
    orderId: PropTypes.string,
};

export default OrderNumber;
